<template>
  <nav-bar title="钢瓶组管理" />
  <content :bottom="76">
    <ul class="list">
      <li v-for="item in list" :key="item.cgId" class="list-item">
        <div class="list-item__name">{{ item.cgName }}</div>
        <div class="list-item__btns">
          <van-row gutter="16">
            <van-col span="8">
              <van-button
                type="primary"
                size="small"
                block
                :to="`/configureCylinderGroup/${item.cgId}`"
              >
                配置销售组
              </van-button>
            </van-col>
            <van-col span="8">
              <van-button
                type="warning"
                size="small"
                :to="`/editCylinderGroup/${item.cgId}`"
                block
              >修改</van-button
              >
            </van-col>
            <van-col span="8">
              <van-button
                type="danger"
                size="small"
                block
                @click="handleDelClick(item)"
                >删除</van-button
              >
            </van-col>
          </van-row>
        </div>
      </li>
    </ul>
    <empty v-if="!list.length" description="暂无数据" />
  </content>
  <div class="btns">
    <van-button type="primary" block to="/addCylinderGroup">
      添加钢瓶组
    </van-button>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { getCyGroupList, deleteCyGroupInfo } from '@/api/cylinderInfo'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
export default {
  name: 'CylinderGroupManagement', // 钢瓶组管理
  setup() {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    // 获取钢瓶组列表
    const list = ref([])
    const getCyGroupListData = async () => {
      // loading
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: '加载中...'
      })
      const { status, data } = await getCyGroupList(companyId.value)
      if (status === 200) {
        list.value = data
      }
      Toast.clear()
    }
    getCyGroupListData()
    // 删除钢瓶组
    const handleDelClick = (item) => {
      Dialog.confirm({
        title: '删除钢瓶组',
        message: `确定删除钢瓶组：${item.cgName}？`
      })
        .then(async () => {
          // on confirm
          Toast.loading({
            duration: 0,
            message: '删除中...',
            forbidClick: true
          })
          // 确认删除钢瓶组
          const { status } = await deleteCyGroupInfo(item.cgId)
          Toast.clear()
          if (status === 200) {
            Toast.success('删除成功')
            setTimeout(() => {
              getCyGroupListData()
            }, 1000)
          }
        })
        .catch(() => {
          // on cancel
        })
    }
    return { list, handleDelClick }
  }
}
</script>

<style lang="scss" scoped>
.btns {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 16px;
  background: #fff;
}
.list {
  margin: 16px;
  .list-item {
    padding: 8px 16px;
    background-color: #fff;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    &__name {
      font-size: 16px;
      margin: 8px 0;
    }
  }
}
</style>
